import { API } from 'aws-amplify';

import {
  GEOFENCES_RECEIVED,
  GEOFENCE_SAVED,
  API_DATA_REQUESTED,
  API_ERROR,
  SET_GEOFENCE_GEOJSON,
  SET_GEOFENCE_NAME,
  SET_GEOFENCE_ID,
  CLEAR_GEOFENCE_STATE,
  GEOFENCE_DELETED,
  QUEUE_NOTIFICATION
} from './actionTypes';

import { requestOptions } from '../constants';

const options = requestOptions;

export const clearState = () => dispatch =>
  dispatch({
    type: CLEAR_GEOFENCE_STATE
  });

export const setId = id => dispatch =>
  dispatch({
    type: SET_GEOFENCE_ID,
    payload: id
  });

export const setName = name => dispatch =>
  dispatch({
    type: SET_GEOFENCE_NAME,
    payload: name
  });

export const setGeoJson = geoJson => dispatch =>
  dispatch({
    type: SET_GEOFENCE_GEOJSON,
    payload: geoJson
  });

export const getGeofences = () => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  API.get('api', '/geofence/list', options)
    .then(res => {
      dispatch({
        type: GEOFENCES_RECEIVED,
        payload: res
      });
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};

export const newGeofence = geofence => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  const body = {
    name: geofence.name,
    geoJson: geofence.geoJson
  };

  API.post('api', '/geofence', { body }, options)
    .then(() => {
      dispatch({
        type: GEOFENCE_SAVED
      });

      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'Geofence created successfully '
        }
      });
      dispatch(getGeofences());
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};

export const updateGeofence = geofence => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  const body = {
    id: geofence.id,
    name: geofence.name,
    geoJson: geofence.geoJson
  };

  API.put('api', '/geofence', { body }, options)
    .then(() => {
      dispatch({
        type: GEOFENCE_SAVED
      });
      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'Geofence updated successfully '
        }
      });
      dispatch(getGeofences());
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};

export const deleteGeofence = ({ id }) => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  API.del('api', `/geofence?geofenceId=${id}`, options)
    .then(() => {
      dispatch({
        type: GEOFENCE_DELETED
      });
      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'Geofence deleted successfully '
        }
      });
      dispatch(getGeofences());
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};
